export default __webpack_public_path__ + "static/media/16.b436745b.jpeg";